import { LoginContainer } from "./pages/LoginPage";
import { TopicsContainer } from "./pages/TopicsPage";
import { UserListContainer } from "./pages/UserListPage";
import { LinesContainer } from "./pages/LinesPage";

export type Page = "lines" | "login" | "topics" | "user_list";

export const Pages: {
  [page in Page]: {
    name: string;
    component: React.ComponentClass;
  };
} = {
  login: {
    component: LoginContainer,
    name: "Log In",
  },
  lines: {
    component: LinesContainer,
    name: "Lines",
  },
  topics: {
    component: TopicsContainer,
    name: "Topics",
  },
  user_list: {
    component: UserListContainer,
    name: "Users",
  },
};



// WEBPACK FOOTER //
// ./src/Page.tsx